'use strict';

import jwtDecode from 'jwt-decode';

/**
 * Extract safe, identifying claims from a JWT for diagnostics.
 * Never returns the raw token; only enough to tell two tokens apart.
 *
 * @param {string|null} token
 * @returns {Object|null} claims, a decode_error marker, or null when no token
 */
export function tokenClaims(token) {
    if (!token) {
        return null;
    }

    try {
        const { jti, iat, exp, sub } = jwtDecode(token);

        return { jti, iat, exp, sub };
    } catch (error) {
        return { decode_error: error.message };
    }
}
